(() => {
  const MOBILE_MAX = 749;

  function isMobile() {
    return window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;
  }

  function initMobileDrawerSubmenuAccordions() {
    if (!isMobile()) return;

    const drawerRoots = document.querySelectorAll(
  '.drawer, dialog.dialog-drawer'
);
    if (!drawerRoots.length) return;

    drawerRoots.forEach((root) => {
      const items = root.querySelectorAll('li');

      items.forEach((item) => {
        if (item.classList.contains('drawer-submenu-ready')) return;

        const submenu =
          item.querySelector(':scope > ul') ||
          item.querySelector(':scope > .menu-list__submenu');

        if (!submenu) return;

        const label =
          item.querySelector(':scope > a') ||
          item.querySelector(':scope > .menu-list__link') ||
          item.querySelector(':scope > span') ||
          item.querySelector(':scope > button') ||
          item.querySelector(':scope > summary');

        if (!label) return;

        item.classList.add('drawer-submenu-item', 'drawer-submenu-ready');
        item.classList.remove('is-open');

        const row = document.createElement('div');
        row.className = 'drawer-submenu-accordion';

        label.parentNode.insertBefore(row, label);
        row.appendChild(label);

        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'drawer-submenu-toggle';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Untermenü ein- oder ausklappen');

        row.appendChild(toggle);

        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const isOpen = item.classList.contains('is-open');

          const siblings = item.parentElement ? Array.from(item.parentElement.children) : [];
          siblings.forEach((sibling) => {
            if (sibling !== item && sibling.classList.contains('drawer-submenu-item')) {
              sibling.classList.remove('is-open');
              const siblingToggle = sibling.querySelector(
                ':scope > .drawer-submenu-accordion .drawer-submenu-toggle'
              );
              if (siblingToggle) siblingToggle.setAttribute('aria-expanded', 'false');
            }
          });

          item.classList.toggle('is-open', !isOpen);
          toggle.setAttribute('aria-expanded', String(!isOpen));
        });
      });
    });
  }

  function resetDesktopState() {
    if (isMobile()) return;

    document.querySelectorAll('.drawer-submenu-item.is-open').forEach((item) => {
      item.classList.remove('is-open');
    });

    document.querySelectorAll('.drawer-submenu-toggle[aria-expanded="true"]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function initAll() {
    initMobileDrawerSubmenuAccordions();
    resetDesktopState();
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);

  window.addEventListener('resize', () => {
    setTimeout(initAll, 50);
  });

  document.addEventListener('click', () => {
    if (!isMobile()) return;
    setTimeout(initMobileDrawerSubmenuAccordions, 50);
  });
})();